import React from 'react';
import { IBanner } from 'utils/types';
import { StyledBanner } from './style';

export const Banner: React.FC<IBanner> = ({
  imageSrc,
  maxWidth = '812px',
  minWidth = '10px',
  maxHeight = 'auto',
  mx = '16px',
}) => {
  return (
    <StyledBanner
      className={'banner'}
      maxWidth={maxWidth}
      minWidth={minWidth}
      maxHeight={maxHeight}
      mx={mx}
    >
      <img className={'banner__image'} src={imageSrc} alt={'value banner'} />
    </StyledBanner>
  );
};
